import { Pais } from "./pais.model";

export class Direccion {
    id: number;
    calle: string;
    numeroDePuerta: number;
    numeroDeApartamento: number;
    localidad: string;
    pais: Pais;
    tipo: string;

    /**
     * Constructor
     *
     * @param direccion
     */
    constructor(direccion) {
        {
            this.id = direccion.id || null;
            this.calle = direccion.calle || "";
            this.numeroDePuerta = direccion.numeroDePuerta || null;
            this.numeroDeApartamento = direccion.numeroDeApartamento;
            this.localidad = direccion.localidad || "";
            this.pais = direccion.pais;
            this.tipo = direccion.tipo || "FISICA";
        }
    }
}
